import * as React from 'react'
import { inject, observer } from 'mobx-react'
import ProductSlider from 'src/components/containers/configurator/ProductSlider'
import { StoreProps } from 'src/stores'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import ProductCardSmall from '../../molecules/configurator/ProductCardSmall'

interface Props extends StoreProps {
  index?: number
}

@inject('confStore')
@observer
export default class AdditionalServices extends React.Component<Props> {
  render() {
    const { confStore, index } = this.props

    const products = confStore.getCatalogue.getProductsByType('OTHERS')

    return (
      <ConfiguratorBox
        title={`${index}. Zusätzliche Produkte und Dienstleistungen`}
        idLabel={`expand-arrow-additional-service`} 
        collapsable>
        <ProductSlider header='Bitte wählen'>
          {products &&
            products.map((p, index) => {
              return <ProductCardSmall product={p} key={p.uuid} idLabel={`additional-${index}`} />
            })}
        </ProductSlider>
      </ConfiguratorBox>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/AdditionalServices.tsx